import type { ComponentType } from 'react';
import {
  AdminAllCertificates,
  AdminOverview,
  CertificateReports,
  EmployeeDashboard,
  ManagerDashboard,
  MyCertificates,
  SupervisorApproved,
  SupervisorPending,
  SupervisorRejected,
} from './screens';

/**
 * Which component serves each `/certifications/:role/:section` route.
 *
 * Keys match the nav item keys in src/app/navigation.ts. Anything not listed
 * falls through to the placeholder, so a module can be filled in screen by
 * screen without breaking navigation.
 */
export const CERTIFICATIONS_SCREENS: Record<string, Record<string, ComponentType>> = {
  employee: {
    dashboard: EmployeeDashboard,
    certificates: MyCertificates,
  },
  supervisor: {
    pending: SupervisorPending,
    approved: SupervisorApproved,
    rejected: SupervisorRejected,
  },
  // Both manager roles render the same screens. What differs is what RLS
  // returns: an Operation Manager is unrestricted, a Manager sees only their
  // assigned hospitals and sections. That is the whole point of doing the
  // scoping in the database — the screens did not need to know.
  'operation-manager': {
    dashboard: ManagerDashboard,
    'certificate-reports': CertificateReports,
  },
  manager: {
    dashboard: ManagerDashboard,
    'certificate-reports': CertificateReports,
  },
  admin: {
    'all-certificates': AdminAllCertificates,
    overview: AdminOverview,
  },
};
